import { theme } from '@prophecy/theme';
import { Ellipsis, Text } from '@prophecy/ui-v3';
import { Fragment } from 'react';
import styled from 'styled-components';

import { BreakdownRow } from './types';
import { UsageBar } from './UsageBar';

/** Grid so every row's label, bar and value line up on shared column widths. */
const BreakdownGrid = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr minmax(0, max-content);
  align-items: center;
  column-gap: ${theme.spaces.x12};
  row-gap: ${theme.spaces.x8};
`;

const RowValue = styled.div`
  min-width: 0;
  text-align: right;
`;

export function BreakdownRows({
  rows,
  color,
  showBar = true
}: {
  rows: BreakdownRow[];
  color: string;
  /** Off for rows that aren't a shared-unit comparison, e.g. activity counts. */
  showBar?: boolean;
}) {
  return (
    <BreakdownGrid>
      {rows.map((row) => (
        <Fragment key={row.label}>
          <Text level='xs' tone={theme.textColor.tertiary}>
            {row.label}
          </Text>
          {showBar ? <UsageBar segments={[{ value: row.ratio, color }]} total={1} /> : <div />}
          <RowValue>
            <Ellipsis tooltip>
              <Text level='xs' weight={theme.fontWeight.medium}>
                {row.value}
              </Text>
            </Ellipsis>
          </RowValue>
        </Fragment>
      ))}
    </BreakdownGrid>
  );
}
